import { render, staticRenderFns } from "./classical-wom-form.vue?vue&type=template&id=4b046213"
import script from "./classical-wom-form.vue?vue&type=script&lang=js"
export * from "./classical-wom-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports